module.exports = __webpack_public_path__ + "static/media/domain5.675854ed.png";